import React, { useState, useEffect } from "react";
import { fetchOrderDetails } from "../helpers/orders";
import { ValidateResponse } from "../helpers/global";
import { Message } from "../../components/Message";
import { Details } from "../../components/Details";
import { List } from "../../components/List";

export function AppOrdersDetails({ orderId, setTitle }) {

    const [state, setState] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        fetchOrderDetails(orderId).then((res) => {

            const response = ValidateResponse(res.data, 'details');

            if (response.status === 'error') {
                setError(response.message, response.status);
            }
            else {
                setState(response.details);
                setIsLoaded(true);
                setTitle(response.details.title);
            }
        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });

    }, [orderId, setTitle]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (state === undefined || state === null || Object.keys(state).length === 0) {
        return (<Message type="noData" />);
    }

    let columns = [
        // West
        //{ content: "Order Details", type: "title", gcId: "west" },
        { key: "status", label: "Status", type: "text", gcId: "west" },
        { key: "createDate", label: "Order datum", type: "date", gcId: "west" },
        { key: "paymentStatus", label: "Betaalstatus", type: "text", gcId: "east" },
        { key: "customerReference", label: "Klantreferentie", type: "text", gcId: "east" },
        { key: "expectedDeliveryDate", label: "Verwachte leverdatum", type: "date", gcId: "east"}
    ];

    if (state.orderGroup=== 'QUOTATION') {
        delete (columns[2]);
    }

    let itemListColumns = [
        { key: "articleCode", label: "Artikelcode", type: "text"},
        { key: "displayName", label: "Naam artikel", type: "text"},
        { key: "serialNumber", label: "Serienummer", type: "text"},
        { key: "quantity", label: "Aantal", type: "text"},
    ];

    // // remove if empty
    // let removeIfEmpty = [
    //     'rentalExtensions',
    //     'endUser',
    //     'birthDate',
    //     'departmentRoom',
    //     'generalUse',
    //     'contactUser',
    //     'contactPhone',
    //     'contactEmail'
    // ];

    // columns.forEach((col, i) => {
    //     if (removeIfEmpty.includes(col.key) && (state[col.key] === null || state[col.key] === "" || state[col.key] === undefined)) {
    //         delete columns[i];
    //     }

    //     if (state.status === 'ACTIVE' && col.key === 'endDate') {
    //         delete columns[i];
    //     }
    //     if (state.status === 'WAITING' && (col.key === 'startDate' || col.key === 'endDate')) {
    //         delete columns[i];
    //     }

    // });

    return (
        <>
            <Details
                columns={columns}
                data={state}
                identifier="details"
            />

            <List
                title={'Producten'}
                columns={itemListColumns}
                data={state.items}
                identifier={"list"}
            />
        </>
    );
}